import { TaskCompletion } from 'graphql-common';
import { IconButtonTypes } from '@lib/components/IconButton/IconButton';
import { TableAction } from '@lib/components/Table/types';

const getTaskReportingTableActions = ({
  onViewTaskCompletionHandler,
}: {
  onViewTaskCompletionHandler: (item?: TaskCompletion) => void;
}): TableAction<TaskCompletion>[] => {
  return [
    {
      id: 'view-action',
      onClick: (item) => onViewTaskCompletionHandler(item),
      icon: 'visibility',
      type: IconButtonTypes.PrimaryOutlined,
    },
  ];
};

export default getTaskReportingTableActions;
